module.exports = __webpack_public_path__ + "static/media/header.86e87ea4.png";